import React from 'react';

// Images
import HeaderLogo from '../../assets/images/logo/logo.png'
import HeaderLogoSticky from '../../assets/images/logo/sticky-logo.png'
import ImgPhoneSupport from '../../assets/images/icon/phone-support.png'
import { useLocation, useNavigate } from 'react-router-dom';




// 
import sidebarLogo from '../../assets/images/logo/black-logo.png'

// 
const TopNavBar = () => {

    const navigate = useNavigate();

    const onHomePage = (e) => {
        e.preventDefault();
        navigate('/');
        window.location.reload();
    }
    const onAboutUs = (e) => {
        e.preventDefault();
        navigate('/about');
        window.location.reload();
    }
    const onServicePage = (e) => {
        e.preventDefault();
        navigate('/service');
        window.location.reload();
    }
    const onServiceDetailPage = (e) => {
        e.preventDefault();
        navigate('/service-detail');
        window.location.reload();
    }
    const onTeamPage = (e) => {
        e.preventDefault();
        navigate('/team');
        window.location.reload();
    }
    const onContactUs = (e) => {
        e.preventDefault();
        navigate('/contact');
        window.location.reload();
    }
    const onBlog = (e) => {
        e.preventDefault();
        navigate('/blog');
        window.location.reload();
    }
    const onBlogDetail = (e) => {
        e.preventDefault();
        navigate('/blogdetail');
        window.location.reload();
    }

    const { pathname } = useLocation();

    const isActive = (path) => {
        return pathname === path ? 'active' : '';
    };

    return (
        <div>
            <header class="header-area style-1">
                <div class="header-menu-area sticky-header">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="cal-12">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="logo">
                                        <a class="standard-logo">
                                            <img src={HeaderLogo} alt="logo" />
                                        </a>
                                        <a class="sticky-logo">
                                            <img src={HeaderLogoSticky} alt="logo" />
                                        </a>
                                        <a class="retina-logo">
                                            <img src={HeaderLogo} alt="logo" />
                                        </a>
                                    </div>
                                    <div class="menu d-inline-block">
                                        <nav id="main-menu" class="main-menu">
                                            <ul>
                                                <li className={isActive('/')}>
                                                    <a href='#' onClick={onHomePage}>Home</a>
                                                </li>
                                                <li className={isActive('/about')}>
                                                    <a href='#' onClick={onAboutUs}>About</a>
                                                </li>
                                                <li className={isActive('/service')}>
                                                    <a href='#' onClick={onServicePage}>Service</a>
                                                </li>
                                                <li className={isActive('/blog')}>
                                                    <a href='#' onClick={onBlog}>Blog</a>
                                                </li>
                                                <li className={isActive('/contact')}>
                                                    <a href='#' onClick={onContactUs}>Contact</a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div class="search-btn-with-cta-btn">
                                        <div class="search-btn-with-btn">
                                            {/* <div class="search-btn-wrapper">
                                                <a href="" class="search-btn">
                                                    <i class="fa fa-magnifying-glass"></i>
                                                </a>
                                            </div> */}
                                            <div class="btn-wrapper">
                                                <a href="" onClick={onContactUs} class="theme-btn">Get A Quote</a>
                                            </div>
                                        </div>
                                        <a href="tel:+919960803355" class="ct-header-btn">
                                            <div class="icon-wrapper">
                                                <div class="icon">
                                                    <img src={ImgPhoneSupport} alt="phone" />
                                                </div>
                                            </div>
                                            <div class="content-wrapper">
                                                <span class="title">Call Us</span>
                                                <span class="text">+919960803355</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="mobile-menu-bar d-lg-none text-end">
                                        <a href="#" class="mobile-menu-toggle-btn"><i class="fa-solid fa-bars"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </header>

            <div class="menu-sidebar-area">
                <div class="menu-sidebar-wrapper">
                    <div class="menu-sidebar-close">
                        <button class="menu-sidebar-close-btn" id="menu_sidebar_close_btn">
                            <i class="fa-solid fa-times"></i>
                        </button>
                    </div>
                    <div class="menu-sidebar-content">
                        <div class="menu-sidebar-logo">
                            <a href="">
                                <img src={sidebarLogo} alt="logo" />
                            </a>
                        </div>
                        <div class="">
                            <ul>
                                <li className={isActive('/')}>
                                    <a href='#' onClick={onHomePage}>Home</a>
                                </li>
                                <li className={isActive('/about')}>
                                    <a href='#' onClick={onAboutUs}>About</a>
                                </li>
                                <li className={isActive('/service')}>
                                    <a href='#' onClick={onServicePage}>Service</a>
                                </li>
                                <li className={isActive('/blog')}>
                                    <a href='#' onClick={onBlog}>Blog</a>
                                </li>
                                <li className={isActive('/contact')}>
                                    <a href='#' onClick={onContactUs}>Contact</a>
                                </li>
                            </ul>
                        </div>
                        <div class="menu-sidebar-content">
                            <div class="menu-sidebar-single-widget">
                                <h5 class="menu-sidebar-title">Contact Info</h5>
                                <div class="header-contact-info">
                                    <span><i class="fa-solid fa-location-dot"></i>A-504, Kool Homes Arena, Patil Nagar, Balewadi, Pune, Maharashtra, 411045, IN</span>
                                    <span><a href="mailto:hr@tktechnico.com"><i
                                        class="fa-regular fa-envelope"></i>hr@tktechnico.com</a> </span>
                                    <span><a href="tel:+919960803355"><i class="fa-solid fa-phone"></i>+919960803355</a></span>
                                </div>
                                <div class="social-profile">
                                    <a href=""><i class="fa-brands fa-facebook-f"></i></a>
                                    <a href=""><i class="fa-brands fa-twitter"></i></a>
                                    <a href=""><i class="fa-brands fa-linkedin-in"></i></a>
                                    <a href=""><i class="fa-brands fa-youtube"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="body-overlay"></div>

        </div>
    );
};

export default TopNavBar;
